export const useStyles = theme => ({
  [`${theme.breakpoints.down('md')} 
      and (orientation: landscape)
      and (min-width: 600px)
      and (max-height: 500px)`]: {
    randomizeSelectionGroup: {
      alignItems: 'flex-start !important',
    },
    squaresRoot: {
      display: 'flex',
      width: '100%',
      marginTop: '25px',
    },
    titleRandomize: {
      width: '40% !important',
      display: 'flex',
      flexDirection: 'column',
    },
    submitButton: {
      marginLeft: '0px !important',
      minWidth: '150px !important',
      [theme.breakpoints.down('xs')]: {
        marginTop: 10,
      },
    },
    cell: {
      height: '30px !important',
    },
    borderButton: {
      minWidth: '150px !important',
      fontSize: '15px !important',
    },
  },
  welcome: {
    padding: '0px !important',
    marginBottom: '20px',
    '& h1': {
      lineHeight: 'unset !important',
    },
    '& h2': {
      margin: '0px',
      color: '#707070',
      lineHeight: 'unset !important',
    },
  },
  welcomeGrid: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  description: {
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  dialog: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  dialogTitle: {
    display: 'flex',
    textAlign: 'center',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    padding: '10px',
    '& h2': {
      fontWeight: '500',
    },
  },
  dialogDecription: {
    fontSize: '20px',
    padding: '20px',
    fontWeight: '300',
  },
  help: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  randomizeSelectionGroup: {
    alignItems: 'flex-end',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
    },
  },
  squaresRow: {
    width: '100%',
  },
  cell: {
    display: 'inline-block',
    textAlign: 'center',
    border: '0.5px solid',
    // minWidth: '20px !important',
    width: '10%',
    height: '60px',
    padding: '0px !important',
    [theme.breakpoints.between('xs', 'sm')]: {
      height: '30px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      height: '40px',
    },
  },
  notAllowedToClick: {
    cursor: 'not-allowed !important',
  },
  actionIcon: {
    fontSize: '1.75rem',
    display: 'inline-block',
    verticalAlign: 'middle',
    marginTop: '15px',
    [theme.breakpoints.between('sm', 'md')]: {
      marginTop: '5px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px',
    },
    margin: 'auto',
    lineHeight: '1',
  },
  removeBox: {
    backgroundColor: '#DE0D0D',
    '& svg': {
      fill: '#fff',
    },
  },
  squaresContainer: {
    // minWidth: '0px !important',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableScrollable: {
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
    // margin: '0 !important',
    padding: '1px',
    position: 'relative',
  },
  squareBoxXAxisLabel: {
    top: '50%',
    border: 0,
    display: 'block',
    padding: 0,
    position: 'absolute',
    transform: 'translate(-47% , -50%) rotate(-90deg)',
    '& span': {
      display: 'block',
      width: '100%',
      textAlign: 'center',
    },
  },
  bottomBtn: {
    justifyContent: 'space-between',
    marginTop: '15px',
    width: '100%',
    display: 'flex',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginBottom: 35,
    },
    [theme.breakpoints.only('xs')]: {
      justifyContent: 'unset',
      width: '100%',
      display: 'block',
    },
    [theme.breakpoints.only('md')]: {
      marginBottom: 48,
    },
  },
  submitButton: {
    minWidth: 180,
    marginLeft: 'auto',
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: 10,
    },
  },
  borderButton: {
    border: '1px solid #A0750E',
    backgroundColor: 'transparent',
    color: '#A0750E',
    boxShadow: 'none',
    minWidth: '180px',
    textAlign: 'right',
    fontSize: '18px',
    letterSpacing: '3.6px',
    padding: '8px 10px',
    // marginRight: '15px',
    marginBottom: '15px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#A0750E',
      color: '#fff',
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },
  titleText: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '1.8em',
    color: 'black',
  },
  shortLogo: {
      width: '120px',
      float: 'left',
      margin: '-8px 2em 0 0',
  },
});
